import { VideoGroupProps } from "modules/video/group/store/actionType";

export enum actionTypes {
    FETCH_VIDEO_CATEGORIES_REQUEST = 'FETCH_VIDEO_CATEGORIES_REQUEST',
    FETCH_VIDEO_CATEGORIES_SUCCESS = 'FETCH_VIDEO_CATEGORIES_SUCCESS',
    FETCH_VIDEO_CATEGORIES_FAIL = 'FETCH_VIDEO_CATEGORIES_FAIL',

    CREATE_VIDEO_CATEGORY_SUCCESS = 'CREATE_VIDEO_CATEGORY_SUCCESS',
    CREATE_VIDEO_CATEGORY_FAIL = 'CREATE_VIDEO_CATEGORY_FAIL',
    UPDATE_VIDEO_CATEGORY_SUCCESS = 'UPDATE_VIDEO_CATEGORY_SUCCESS',
    UPDATE_VIDEO_CATEGORY_FAIL = 'UPDATE_VIDEO_CATEGORY_FAIL',
    DELETE_VIDEO_CATEGORY_SUCCESS = 'DELETE_VIDEO_CATEGORY_SUCCESS',
    DELETE_VIDEO_CATEGORY_FAIL = 'DELETE_VIDEO_CATEGORY_FAIL',
}

export interface GenericVideoCategoryStateProps {
    isLoading: boolean;
    status: stateStatusType | null;
    error: string | null;
}

export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface VideoCategoryInput{
    name:string;
    description:string;
    group_id:string;
    category_order:number;
}
export interface UpdateVideoCategoryInput {
    name: string;
    description: string;
    group_id: string;
    folder_id: string;
    category_id: string;
    category_order:number;
  }

export interface VideoCategoryProps {
    name: string;
    id: string;
    description:string;
    folder_id: string;
    group_id:string;
    group:VideoGroupProps;
    category_order:number;
}

//FetchVideoCategories
export interface FetchVideoCategoriesRequestAction {
    type: actionTypes.FETCH_VIDEO_CATEGORIES_REQUEST;
}

export interface FetchVideoCategoriesSuccessAction {
    type: actionTypes.FETCH_VIDEO_CATEGORIES_SUCCESS;
    payload: VideoCategoryProps[];
}

export interface FetchVideoCategoriesFailureAction {
    type: actionTypes.FETCH_VIDEO_CATEGORIES_FAIL;
    payload: string;
}
//CreateVideoCategory
export interface CreateVideoCategorySuccessAction {
    type: actionTypes.CREATE_VIDEO_CATEGORY_SUCCESS;
    payload: VideoCategoryProps[];
}
export interface CreateVideoCategoryFailAction {
    type: actionTypes.CREATE_VIDEO_CATEGORY_FAIL;
    payload: string;
}

//UpdateVideoCategory
export interface UpdateVideoCategorySuccessAction {
    type: actionTypes.UPDATE_VIDEO_CATEGORY_SUCCESS;
    payload: VideoCategoryProps;
}
export interface UpdateVideoCategoryFailAction {
    type: actionTypes.UPDATE_VIDEO_CATEGORY_FAIL;
    payload: string;
}

//DeleteVideoCategory
export interface DeleteVideoCategorySuccessAction {
    type: actionTypes.DELETE_VIDEO_CATEGORY_SUCCESS;
    payload: string;
}
export interface DeleteVideoCategoryFailureAction {
    type: actionTypes.DELETE_VIDEO_CATEGORY_FAIL;
    payload: string;
}


export type VideoCategoriesActions =
    | FetchVideoCategoriesRequestAction
    | FetchVideoCategoriesSuccessAction
    | FetchVideoCategoriesFailureAction
    | CreateVideoCategorySuccessAction
    | CreateVideoCategoryFailAction
    | UpdateVideoCategorySuccessAction
    | UpdateVideoCategoryFailAction
    | DeleteVideoCategorySuccessAction
    | DeleteVideoCategoryFailureAction;
